import { getEnv } from '@/config/get-env'

const env = getEnv()

const brokerUrl = {
  local: encodeURIComponent(
    'https://mk-oauth-broker-service-dev.kinsta.services/oauth'
  ),
  dev: encodeURIComponent(
    'https://mk-oauth-broker-service-dev.kinsta.services/oauth'
  ),
  staging: encodeURIComponent(
    'https://mk-oauth-broker-service-staging.kinsta.services/oauth'
  ),
  production: encodeURIComponent(
    'https://mk-oauth-broker-service.kinsta.services/oauth'
  ),
}[env]

const clientId = {
  local: {
    github: 'Iv1.47318af6d8500f31',
    bitbucket: 'TH9XLRZDEq6CsUJY5P',
    gitlab: 'ecba980bde1c5ca2931c2bb457d4cc1e7e21988bc6dd2150d2adf8adaad2b349',
  },
  dev: {
    github: 'Iv1.47318af6d8500f31',
    bitbucket: 'TH9XLRZDEq6CsUJY5P',
    gitlab: 'ecba980bde1c5ca2931c2bb457d4cc1e7e21988bc6dd2150d2adf8adaad2b349',
  },
  staging: {
    github: 'Iv1.b766a6ed2e570ada',
    bitbucket: 'f7CBcaPERbjy5cANYB',
    gitlab: 'bc5d92f3948635eb8702026b31acc755e0d38c2abb5896d1820d6df9ee232a8e',
  },
  production: {
    github: 'Iv1.77fc0f6c429309a4',
    bitbucket: '5Jf3cEKamaVZ6KaBbN',
    gitlab: '36cdeefe043edcb32e944ad4dfa2e276d474241ad03945421b254a61ae0a22e1',
  },
}[env]

export const gitAuthUrls = {
  github: `https://github.com/login/oauth/authorize?allow_signup=true&client_id=${clientId.github}&redirect_uri=${brokerUrl}/github&scope=user`,
  bitbucket: `https://bitbucket.org/site/oauth2/authorize?client_id=${clientId.bitbucket}&redirect_uri=${brokerUrl}/bitbucket&response_type=code`,
  gitlab: `https://gitlab.com/oauth/authorize?client_id=${clientId.gitlab}&redirect_uri=${brokerUrl}/gitlab&response_type=code&scope=api`,
}
